// plugins/supabase.js
import { createClient } from '@supabase/supabase-js';

export default defineNuxtPlugin(async (nuxtApp) => {
  try {
    const config = useRuntimeConfig();

    const supabaseUrl = config.public.SUPABASE_URL;
    const supabaseAnonKey = config.public.SUPABASE_KEY;

    if (!supabaseUrl || !supabaseAnonKey) {
      throw new Error(
        `Supabase configuration missing: URL=${!!supabaseUrl}, Key=${!!supabaseAnonKey}`
      );
    }

    if (process.client) {
      localStorage.setItem('supabaseUrl', supabaseUrl);
      localStorage.setItem('supabaseAnonKey', supabaseAnonKey);
    }

    const supabase = createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true, // handles PKCE code exchange automatically
      },
    });

    if (process.client) {
      // Let detectSessionInUrl handle everything, then clean the URL
      const {
        data: { session },
      } = await supabase.auth.getSession();

      if (session) {
        localStorage.setItem('session', JSON.stringify(session));
      }

      // Clean up URL if there's a code param (PKCE) or hash tokens (implicit)
      const url = new URL(window.location.href);
      if (
        url.searchParams.has('code') ||
        window.location.hash.includes('access_token=')
      ) {
        window.history.replaceState(
          {},
          document.title,
          window.location.pathname
        );
      }

      // Single source of truth for session in localStorage
      supabase.auth.onAuthStateChange((event, session) => {
        if (session) {
          localStorage.setItem('session', JSON.stringify(session));
        } else {
          localStorage.removeItem('session');
        }
      });

      // Auto-refresh token every 30 minutes
      setInterval(
        async () => {
          const { data, error } = await supabase.auth.refreshSession();
          if (!error && data.session) {
            localStorage.setItem('session', JSON.stringify(data.session));
          }
        },
        30 * 60 * 1000
      );
    }

    nuxtApp.provide('supabase', supabase);
  } catch (error) {
    console.error('Error initializing Supabase client:', error);
  }
});

export const useSupabaseClient = () => {
  const nuxtApp = useNuxtApp();
  return nuxtApp.$supabase;
};
